(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["alia-trigger-button"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-awe-alia-trigger]').forEach(trigger => {
      trigger.addEventListener('click', event => {
        const breakpoint = Number(trigger.getAttribute('data-awe-alia-mobile-breakpoint')) || 750;
        const isMobile = !window.matchMedia(`(min-width: ${breakpoint}px)`).matches;
        const campaignId = isMobile
          ? trigger.getAttribute('data-awe-alia-mobile-campaign')
          : trigger.getAttribute('data-awe-alia-desktop-campaign');

        if (!campaignId) return;

        if (trigger.tagName === 'A' && trigger.hasAttribute('href')) {
          event.preventDefault();
        }

        window.alia = window.alia || [];
        window.alia.push({ type: 'open', campaignID: Number(campaignId), ignoreTargeting: true });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
